import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useObservableState } from 'observable-hooks';
import { RxCollection } from 'rxdb';
import { defer, map, of } from 'rxjs';

import {
	BOOKING_NUMBER_QUERY_PARAM,
	TICKET_QUERY_PARAM,
} from '@mopla/constants';
import { PassengerBookingView } from '@mopla/data-models';

import { useBusinessLayer } from '../business-logic';

export const useOpenedBooking = () => {
	const bl = useBusinessLayer();
	const [query] = useSearchParams();

	/** Serves both screens: activities writes `bookingNumber`, legacy Tickets writes `ticket`. */
	const openedBookingNumber =
		query.get(BOOKING_NUMBER_QUERY_PARAM) ?? query.get(TICKET_QUERY_PARAM);

	const booking$ = useMemo(() => {
		return defer(() => {
			if (!openedBookingNumber) {
				return of(null);
			}

			return (bl.db['passenger_booking'] as RxCollection<PassengerBookingView>)
				.findOne(openedBookingNumber)
				.$.pipe(map((b) => b && (b.toJSON() as PassengerBookingView)));
		});
	}, [bl.db, openedBookingNumber]);

	return useObservableState(booking$);
};
